'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { Loader2 } from 'lucide-react';
import { useI18n } from '@/lib/i18n';
export function LogoutRedirect() {
  const {
    t
  } = useI18n();
  const router = useRouter();
  useEffect(() => {
    router.replace('/login');
  }, [router]);
  return <div className="min-h-screen flex items-center justify-center" data-sentry-component="LogoutRedirect" data-sentry-source-file="LogoutRedirect.tsx">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary mx-auto mb-4" data-sentry-element="Loader2" data-sentry-source-file="LogoutRedirect.tsx" />
        <p className="text-gray-600">{t('common.logging_out')}</p>
      </div>
    </div>;
}